<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">商户：</span>
        </div>
        <el-select v-model="formData.enterpriseCode" filterable remote reserve-keyword placeholder="请输入关键词" :loading="enterpriseLoading" size="mini" style="width: 280px" :remote-method="enterpriseRemoteMethod">
          <el-option v-for="item in enterpriseList" :key="item.enterpriseCode" :label="item.enterpriseName" :value="item.enterpriseCode"></el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">优惠券：</span>
        </div>
        <el-select v-model="formData.parkingCouponSaleCode" size="small" style="width: 280px">
          <el-option v-for="item in couponList" :key="item.code"
                     :label="item._label" :value="item.code">
          </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">优惠券类型：</span>
        </div>
        <el-input v-model="formData.couponType" size="small" style="width: 280px" disabled />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">退券张数：</span>
        </div>
        <el-input v-model="formData.returnNum" size="small" style="width: 280px" >
          <template slot="append">张</template>
        </el-input>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">退券金额：</span>
        </div>
        <el-input v-model="formData.returnMoney" size="small" style="width: 280px" >
          <template slot="append">元</template>
        </el-input>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">退券时间：</span>
        </div>
        <el-date-picker v-model="formData.returnTime" type="date" style="width: 280px" value-format="yyyy-MM-dd" placeholder="退券时间" size="small"></el-date-picker>
      </div>
      <div class="form-line">
        <div class="textBox">
<!--          <b class="red">*</b>-->
          <span class="line-text">备注：</span>
        </div>
        <el-input v-model="formData.memo" size="small" style="width: 280px" />
      </div>
      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import md5 from 'js-md5'
  import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../../components/Button/ButtonCancel'
  import {api} from '../../../api/ParkingService'
  import {errorHandler} from '../../../../utils/errorHandler'
  import {nError, nSuccess} from '../../../../utils/notice'
  import {pattern} from '../../../../utils/regular'

  export default {
    components: {
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'coupon-put-on-the-shelves-add',
    data () {
      return {
        breadcrumb: [{
          value: '智慧停车',
          name: 'parking-device-management'
        }, {
          value: '退券'
        }],
        mainTitle: '退券',
        subheading: '',

        payTypeList: [
          { code: '1', name: '微信' },
          { code: '2', name: '支付宝' },
          { code: '3', name: '银行转账' },
          { code: '4', name: '现金' },
          { code: '5', name: '其他' },
        ],
        enterpriseLoading: false,
        enterpriseList: [],
        couponList: [],
        formData: {
          parkingCouponSaleCode: '',
          enterpriseName: '',
          enterpriseCode: '',
          couponCode: '',
          couponName: '',
          couponType: '',
          returnNum: '',
          returnMoney: '',
          returnTime: '',
          memo: '',
        }
      }
    },
    created () {
      this.enterpriseRemoteMethod()
      this.getCouponList()
    },
    methods: {
      // 住户搜索
      enterpriseRemoteMethod (query) {
        this.enterpriseLoading = true;
        this.$axios.post(api.getParkingCouponSaleEnterpriseList, {
          searchKey: query
        })
          .then(res => {
            if (res.data.retCode === 1) {
              this.enterpriseLoading = false;
              let data = res.data.data
              this.enterpriseList = data
            }
          })
          .catch(errorHandler('获取住户列表失败'))
      },
      // 获取住户下可退的优惠券
      parkingCouponSaleGetList () {
        this.$axios.post(api.parkingCouponSaleGetList, {
          enterpriseCode: this.formData.enterpriseCode
        })
          .then(res => {
            let data = res.data.data
            data.map(v => {
              if (v.couponType === "金额") {
                v.denomination = `面额:${v.denominationMoney}元`;
              } else {
                if (!v.denominationHour) {
                  v.denomination = `面额:${v.denominationMinite}分钟`;
                } else {
                  v.denomination = `面额:${
                    v.denominationHour
                  }小时${v.denominationMinite || 0}分钟`;
                }
              }
              v._label = `${v.couponName}/${v.denomination}/总张数:${v.saleTotalNum}/售价:${v.saleMoney}元`
            })
            this.couponList = res.data.data
          })
          .catch(errorHandler('获取优惠券列表失败'))
      },
      toMangePage () {
        this.$router.push({
          name: 'coupon-refund'
        })
      },
      // 确认添加
      confirm () {
        if (!this.formData.enterpriseCode) {
          nError('请选择商户')
          return false
        }
        if (!this.formData.returnNum) {
          nError('请输入退券张数')
          return false
        }
        if (!this.formData.returnMoney) {
          nError('请输入退券金额')
          return false
        }
        if (!this.formData.returnTime) {
          nError('请选择退券时间')
          return false
        }
        this.$axios.post(api.parkingCouponReturnAdd, this.formData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('退券成功')
              this.toMangePage()
            }
          })
          .catch(errorHandler('退券失败'))
      },
      cancel () {
        this.toMangePage()
      }
    },
    watch: {
      'formData.enterpriseCode': {
        handler(newName, oldName) {
          this.enterpriseList.map(v => {
            if (v.enterpriseCode === this.formData.enterpriseCode) {
              this.formData.enterpriseName = v.enterpriseName
              this.parkingCouponSaleGetList()
            }
          })
        },
        deep: true
      },
      'formData.parkingCouponSaleCode': {
        handler(newName, oldName) {
          this.couponList.map(v => {
            if (v.code === this.formData.parkingCouponSaleCode) {
              this.formData.couponCode = v.couponCode
              this.formData.couponName = v.couponName
              this.formData.couponType = v.couponType
            }
          })
        },
        deep: true
      },
      couponTimeValue (val) {
        if (this.couponTimeValue) {
          this.formData.startTime = this.couponTimeValue[0] || ''
          this.formData.endTime = this.couponTimeValue[1] || ''
        } else {
          this.formData.startTime = ''
          this.formData.endTime = ''
        }
      }
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
  }
  .form-line {
    margin: 20px 0;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 120px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/ParkingCoupon/CouponRefund/CouponRefundAdd.vue